import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { LockOpen } from '@mui/icons-material'

import { IconButton } from '@mui/material'
import { formatToCPF } from 'brazilian-values'
import { DialogConfirm } from 'components'
import { put } from 'services/api'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import jwtDecode from 'jwt-decode'

import moment from 'moment'
import styles from './styles'


function BlockedTable(props) {
  const { tableData, handleUpdate } = props
  const classes = styles()

  const token = useSelector((state) => state.auth.access_token)
  const decoded = jwtDecode(token)
  const username = decoded?.extras?.name
  const email = decoded?.sub

  const [open, setOpen] = useState(false)
  const [currentItem, setCurrentItem] = useState(null)

  const handleUnblockClick = (item) => {
    setCurrentItem(item)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleUnlock = () => {
    handleClose()
    put({
      url: '/antifraude/cpf_release',
      token: token,
      data: { cpf: currentItem.cpf, username, email },
    })
      .then(() => {
        toast.success('Candidato desbloqueado com sucesso.')
        handleUpdate()
      })
      .catch((error) => {
        console.error(error)
        toast.error(
          'Houve um erro ao desbloquear o candidato, por favor tente novamente',
        )
      })
  }

  return (
    <div>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>CPF</th>
            <th>Detalhes</th>
            <th>Data</th>
            <th>Hora</th>
            <th>Desbloquear</th>
          </tr>
        </thead>
        <tbody>
          {tableData.length === 0 && (
            <tr key="-1">
              <td colSpan={8}>Nenhum registro encontrado.</td>
            </tr>
          )}
          {tableData.map((item) => {
            return (
              <tr key={item.cpf}>
                <td>{formatToCPF(item.cpf)}</td>
                <td>{item.block_reason ?? ''}</td>
                <td>{item.blocked_at ? moment(item.blocked_at.split(' ')[0]).format('DD/MM/yyyy') : ''}</td>
                <td>{item.blocked_at ? moment(item.blocked_at.split(' ')[1]).format('HH:mm:SS') : ''}</td>
                <td>
                  <div>
                    <IconButton
                      onClick={() => handleUnblockClick(item)}
                      disabled={item.number_of_blocks > 2}
                    >
                      <LockOpen />
                    </IconButton>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <DialogConfirm
        open={open && currentItem !== null}
        onCancel={handleClose}
        onConfirm={handleUnlock}
        btnCancelText="cancelar"
        title="Tem certeza de que deseja desbloquear este candidato?"
      >
        Essa ação é irreversível e não poderá ser desfeita.
      </DialogConfirm>
    </div>
  )
}

BlockedTable.propTypes = {
  tableData: PropTypes.array.isRequired,
  handleUpdate: PropTypes.func.isRequired,
}

export default BlockedTable
